"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tableCellActionsClassNames: function() {
        return tableCellActionsClassNames;
    },
    useTableCellActionsStyles_unstable: function() {
        return useTableCellActionsStyles_unstable;
    }
});
const _react = require("@griffel/react");
const tableCellActionsClassNames = {
    root: 'fui-TableCellActions'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        De3pzq: "f1u2r49w",
        qhf8xq: "f1euv43f",
        j35jbq: [
            "f10k790i",
            "f1xynx9j"
        ],
        Bhzewxz: "f1i1t8d1",
        Bz10aip: "f188r07x",
        abs64n: "fk73vx1",
        Frg6f3: [
            "fcgxt0o",
            "f1ujusj6"
        ]
    },
    visible: {
        abs64n: "f5p0z4x"
    }
}, {
    d: [
        ".f1u2r49w{background-color:inherit;}",
        ".f1euv43f{position:absolute;}",
        ".f10k790i{right:0px;}",
        ".f1xynx9j{left:0px;}",
        ".f1i1t8d1{top:50%;}",
        ".f188r07x{transform:translateY(-50%);}",
        ".fk73vx1{opacity:0;}",
        ".fcgxt0o{margin-left:auto;}",
        ".f1ujusj6{margin-right:auto;}",
        ".f5p0z4x{opacity:1;}"
    ]
});
const useTableCellActionsStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(tableCellActionsClassNames.root, styles.root, state.visible && styles.visible, state.root.className);
    return state;
}; //# sourceMappingURL=useTableCellActionsStyles.styles.js.map
